/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./accountMgmtModules.vue?vue&type=template&id=05f8dd0a"
import script from "./accountMgmtModules.vue?vue&type=script&lang=js"
export * from "./accountMgmtModules.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports